"use strict";
/**
 * Craft Project API Types
 *
 * Response types are derived from database record types via SanitizedRecord<T>,
 * which strips all InternalFields (DynamoDB keys, scanning/moderation/security metadata).
 * Request types remain standalone interfaces (Requirement 9).
 *
 * Derivation chains:
 * - CraftProjectResponse ← SanitizedRecord<CraftProjectDisplayRecord> &
 *     Partial<SanitizedRecord<CraftProjectDetailsRecord>> + extension
 *     (sanitizeProject remaps identity_id → creator_id)
 * - CraftProjectDisplayResponse ← SanitizedRecord<CraftProjectDisplayRecord>
 *     (sanitizeProject remaps identity_id → creator_id)
 * - ProjectTempResponse ← SanitizedRecord<CraftProjectTempRecord> + extension
 *     (handler returns identity_id directly — no sanitizeProject)
 * - UserCraftProjectResponse ← SanitizedRecord<CraftProjectDisplayRecord>
 *     (handler manually constructs — includes identity_id directly)
 */
Object.defineProperty(exports, "__esModule", { value: true });
